export const AG_GRID_LOCALE_PT_BR = {
  // Filtros
  selectAll: '(Selecionar Todos)',
  selectAllSearchResults: '(Selecionar Todos os Resultados)',
  addCurrentSelectionToFilter: 'Adicionar seleção ao filtro',
  searchOoo: 'Buscar...',
  blanks: '(Em branco)',
  noMatches: 'Sem correspondências',

  // Filtros numéricos e de texto
  filterOoo: 'Filtrar...',
  equals: 'Igual a',
  notEqual: 'Diferente de',
  blank: 'Em branco',
  notBlank: 'Não está em branco',
  empty: 'Escolha uma opção',

  // Filtro Numérico
  lessThan: 'Menor que',
  greaterThan: 'Maior que',
  lessThanOrEqual: 'Menor ou igual a',
  greaterThanOrEqual: 'Maior ou igual a',
  inRange: 'Entre',
  inRangeStart: 'De',
  inRangeEnd: 'Até',

  // Filtro de Texto
  contains: 'Contém',
  notContains: 'Não contém',
  startsWith: 'Começa com',
  endsWith: 'Termina com',

  // Filtro de Data
  dateFormatOoo: 'dd/mm/yyyy',
  before: 'Antes',
  after: 'Depois',

  // Condições do Filtro
  andCondition: 'E',
  orCondition: 'OU',

  // Botões do Filtro
  applyFilter: 'Aplicar',
  resetFilter: 'Redefinir',
  clearFilter: 'Limpar',
  cancelFilter: 'Cancelar',

  // Títulos do Filtro
  textFilter: 'Filtro de Texto',
  numberFilter: 'Filtro Numérico',
  dateFilter: 'Filtro de Data',
  setFilter: 'Filtro de Conjunto',

  // Filtro de Grupo
  groupFilterSelect: 'Selecionar campo:',

  // Barra lateral
  columns: 'Colunas',
  filters: 'Filtros',

  // Painel de colunas
  pivotMode: 'Modo Pivot',
  groups: 'Agrupamentos',
  rowGroupColumnsEmptyMessage: 'Arraste aqui para agrupar',
  values: 'Valores',
  valueColumnsEmptyMessage: 'Arraste aqui para agregar',
  pivots: 'Rótulos de Coluna',
  pivotColumnsEmptyMessage: 'Arraste aqui para rotular',

  // Cabeçalho da coluna agrupada
  group: 'Grupo',

  // Arrastar linha
  rowDragRow: 'linha',
  rowDragRows: 'linhas',

  // Outros
  loadingOoo: 'Carregando...',
  loadingError: 'Erro',
  noRowsToShow: 'Nenhum registro encontrado',
  enabled: 'Ativado',

  // Menu
  pinColumn: 'Fixar Coluna',
  pinLeft: 'Fixar à Esquerda',
  pinRight: 'Fixar à Direita',
  noPin: 'Desafixar',
  valueAggregation: 'Agregação',
  noAggregation: 'Nenhuma',
  autosizeThiscolumn: 'Ajustar Esta Coluna',
  autosizeAllColumns: 'Ajustar Todas as Colunas',
  groupBy: 'Agrupar por',
  ungroupBy: 'Desagrupar por',
  ungroupAll: 'Desagrupar Todos',
  addToValues: 'Adicionar ${variable} aos valores',
  removeFromValues: 'Remover ${variable} dos valores',
  addToLabels: 'Adicionar ${variable} aos rótulos',
  removeFromLabels: 'Remover ${variable} dos rótulos',
  resetColumns: 'Redefinir Colunas',
  expandAll: 'Expandir Todos',
  collapseAll: 'Recolher Todos',
  copy: 'Copiar',
  ctrlC: 'Ctrl+C',
  ctrlX: 'Ctrl+X',
  copyWithHeaders: 'Copiar com Cabeçalhos',
  copyWithGroupHeaders: 'Copiar com Cabeçalhos de Grupo',
  cut: 'Recortar',
  paste: 'Colar',
  ctrlV: 'Ctrl+V',
  export: 'Exportar',
  csvExport: 'Exportar CSV',
  excelExport: 'Exportar Excel',
  columnFilter: 'Filtro de Coluna',
  columnChooser: 'Selecionar Colunas',
  sortAscending: 'Ordem Crescente',
  sortDescending: 'Ordem Decrescente',
  sortUnSort: 'Limpar Ordenação',

  // Rodapé e barra de status
  sum: 'Soma',
  first: 'Primeiro',
  last: 'Último',
  min: 'Mínimo',
  max: 'Máximo',
  none: 'Nenhum',
  count: 'Contagem',
  avg: 'Média',
  filteredRows: 'Filtrado',
  selectedRows: 'Selecionado',
  totalRows: 'Total',
  totalAndFilteredRows: 'Linhas',
  more: 'Mais',
  to: 'até',
  of: 'de',
  page: 'Página',
  pageLastRowUnknown: '...',
  nextPage: 'Próxima Página',
  lastPage: 'Última Página',
  firstPage: 'Primeira Página',
  previousPage: 'Página Anterior',
  pageSizeSelectorLabel: 'Exibindo',
  footerTotal: 'Total',

  // Outros dados
  thousandSeparator: '.',
  decimalSeparator: ',',
  true: 'Verdadeiro',
  false: 'Falso',
  invalidDate: 'Data inválida',
  invalidNumber: 'Número inválido',
  january: 'Janeiro',
  february: 'Fevereiro',
  march: 'Março',
  april: 'Abril',
  may: 'Maio',
  june: 'Junho',
  july: 'Julho',
  august: 'Agosto',
  september: 'Setembro',
  october: 'Outubro',
  november: 'Novembro',
  december: 'Dezembro',
}
